"use strict";

// ============================================================
// Системные константы.
// ============================================================

var supplyInfoShortNameArray = ['Ф', 'Р', 'ПП', 'ОП', 'ОТС', 'ТС', 'ОСЛ', 'СЛ', 'ПСЗ', 'Н', 'З', '*'];
var supplyInfoDictionary = {
  'Ф': '<div class="text-left"><b>Ф</b> - Формируется заказ</div>',
  'Р': '<div class="text-left"><b>Р</b> - Заказ размещён у поставщика</div>',
  'ПП': '<div class="text-left"><b>ПП</b> - Размещение заказа подтверждено поставщиком</div>',
  'ОП': '<div class="text-left"><b>ОП</b> - Номенклатура отгружена поставщиком</div>',
  'ТС': '<div class="text-left"><b>ТС</b> - Номенклатура получена на транзитный склад</div>',
  'ОТС': '<div class="text-left"><b>ОТС</b> - Номенклатура отгружена с транзитного склада</div>',
  'СЛ': '<div class="text-left"><b>СЛ</b> - Номенклатура получена на склад Treolan</div>',
  'ОСЛ': '<div class="text-left"><b>ОСЛ</b> - Номенклатура на оприходовании на складе Treolan</div>',
  'ПСЗ': '<div class="text-left"><b>ПСЗ</b - Поступление номенклатуры на склад Treolan задержано</div>',
  'Н': '<div class="text-left"><b>Н</b> - Прогноз не возможен</div>',
  'З': '<div class="text-left"><b>З</b> - Задержка на данном статусе</div>',
  '*': '<div class="text-left"><b>*</b> - Дата указана отделом логистики</div>'
};
function getSupplyInfoTemplateParts(targetText) {
  var contentTemplateParts = [];
  $.each(supplyInfoShortNameArray, function (_, shortName) {
    if (shortName === "ТС" && contentTemplateParts.includes(supplyInfoDictionary["ОТС"]) || shortName === "СЛ" && contentTemplateParts.includes(supplyInfoDictionary["ОСЛ"])) {
      return;
    }
    if (targetText != null && targetText.includes(shortName)) {
      contentTemplateParts.push(supplyInfoDictionary[shortName]);
    }
  });
  return contentTemplateParts;
}